document.addEventListener("DOMContentLoaded", function() {
  var lang = window.location.pathname.split("/")[1];
  if (lang !== "es") return;

  var dict = {
    // --- Option labels ---
    "Choose Cake size": "Elige tama\u00f1o de tarta",
    "Choose Cake shape": "Elige forma de tarta",
    "Choose Cake flavor": "Elige sabor de tarta",
    "Choose Cake Flavor": "Elige sabor de tarta",
    "Choose Bento cake flavor": "Elige sabor de tarta bento",
    "Choose Filling": "Elige relleno",
    "Choose Add bows": "Elige a\u00f1adir lazos",
    "Choose Edible print": "Elige impresi\u00f3n comestible",
    "Choose Pickup / delivery time": "Elige horario de recogida / entrega",
    "Choose Pickup/delivery time": "Elige horario de recogida / entrega",

    // --- Cake sizes ---
    "Inimini (serves 5)": "Inimini (para 5 personas)",
    "Chiquito 2 layer (serves 10)": "Chiquito 2 capas (para 10 personas)",
    "Chiquito 3 layer (serves 15)": "Chiquito 3 capas (para 15 personas)",

    // --- Cake shapes ---
    "Round shape": "Forma redonda",
    "Heart shape": "Forma de coraz\u00f3n",
    "heart shaped": "Forma de coraz\u00f3n",
    "round cake": "Tarta redonda",
    "Heart shaped cake": "Tarta en forma de coraz\u00f3n",

    // --- Cake flavors ---
    "Red Velvet & Oreo": "Red Velvet y Oreo",
    "Chocolate & fudgy choco": "Chocolate y chocolate fondant",
    "Vanilla & white chocolate Filipino cookies": "Vainilla y galletas Filipinas de chocolate blanco",
    "Carrot cake & cream cheese frosting": "Tarta de zanahoria y glaseado de queso crema",
    "Carrot Cake": "Tarta de zanahoria",
    "Chocolate": "Chocolate",
    "Red Velvet": "Red Velvet",
    "Vanilla": "Vainilla",

    // --- Fillings ---
    "Cream Cheese": "Queso crema",
    "Chocolate Filipino Cookie": "Galleta Filipina de chocolate",
    "Lemon Curd (comes with cream cheese frosting)": "Lemon Curd (incluye glaseado de queso crema)",
    "Mixed Berries": "Frutos del bosque",
    "Oreo": "Oreo",
    "Biscoff (Lotus speculoos)": "Biscoff (Lotus speculoos)",
    "Salted Caramel": "Caramelo salado",
    "Fudgy choco": "Chocolate fondant",

    // --- Buttercream techniques ---
    "1 Color": "1 Color",
    "Waves": "Ondas",
    "Marble": "M\u00e1rmol",
    "Experimental": "Experimental",
    "Paddle Pop": "Paddle Pop",
    "Rustic": "R\u00fastico",
    "Naked": "Desnudo",
    "Ombre": "Ombr\u00e9",
    "Speckled": "Moteado",
    "Sponged": "Esponjado",

    // --- Colors ---
    "Pink": "Rosa",
    "Hot pink": "Rosa intenso",
    "Light pink": "Rosa claro",
    "Yellow": "Amarillo",
    "Orange": "Naranja",
    "Red": "Rojo",
    "Gooseberry": "Grosella",
    "Eucalyptus": "Eucalipto",
    "Blue": "Azul",
    "White": "Blanco",
    "Black": "Negro",
    "Navy blue": "Azul marino",
    "Ice blue": "Azul hielo",
    "Baby blue": "Azul beb\u00e9",
    "Turqoise": "Turquesa",
    "Aqua": "Aguamarina",
    "Sea green": "Verde mar",
    "Grey": "Gris",
    "Leaf green": "Verde hoja",
    "Mint green": "Verde menta",
    "Bright green": "Verde brillante",
    "Burgundy": "Borgo\u00f1a",
    "Lila": "Lila",
    "Purple": "Morado",
    "Peach": "Melocot\u00f3n",
    "Cream": "Crema",
    "Poppy": "Amapola",

    // --- Bows ---
    "No\u201a thank you": "No, gracias",
    "No thanks": "No, gracias",
    "Yes\u201a light pink": "S\u00ed, rosa claro",
    "Yes\u201a hot pink": "S\u00ed, rosa intenso",
    "Yes\u201a red": "S\u00ed, rojo",
    "Yes\u201a blue": "S\u00ed, azul",
    "Yes\u201a white": "S\u00ed, blanco",
    "Yes\u201a black": "S\u00ed, negro",
    "yes\u201a gold.": "S\u00ed, dorado.",
    "yes\u201a light pink.": "S\u00ed, rosa claro.",
    "yes\u201a red.": "S\u00ed, rojo.",

    // --- Edible print ---
    "Add an edible print to the top of your cake": "A\u00f1adir impresi\u00f3n comestible en la parte superior de tu tarta",
    "Add an edible print to the top of my cake": "A\u00f1adir impresi\u00f3n comestible en la parte superior de mi tarta",
    "Add an edible print to the side of my cake": "A\u00f1adir impresi\u00f3n comestible en el lateral de mi tarta",
    "Add an edible print to the top and the side of my cake": "A\u00f1adir impresi\u00f3n comestible en la parte superior y el lateral de mi tarta",

    // --- Extras ---
    "Look vintage (decoraci\u00f3n con manga pastelera)": "Look vintage (decoraci\u00f3n con manga pastelera)",
    "Gender reveal cake": "Tarta de revelaci\u00f3n de g\u00e9nero",
    "Kids theme (tell us more in the comments)": "Tema infantil (cu\u00e9ntanos m\u00e1s en los comentarios)",
    "Schleich animal with party hat": "Animal Schleich con gorro de fiesta",
    "Add bows (let us know what color in the comments)": "A\u00f1adir lazos (d\u00ednos qu\u00e9 color en los comentarios)",
    "Add cherries": "A\u00f1adir cerezas",
    "Add glitter cherries (choose pink/red/gold in the comments)": "A\u00f1adir cerezas con purpurina (elige rosa/rojo/dorado en los comentarios)",

    // --- Pickup / delivery ---
    "Weekdays 10:00-13:00": "Entre semana 10:00-13:00",
    "Weekdays 11:00-13:00": "Entre semana 11:00-13:00",
    "Weekdays 13:00-16:00": "Entre semana 13:00-16:00",
    "Saturdays 10:00-15:00": "S\u00e1bados 10:00-15:00",
    "Saturdays 11:00-15:00": "S\u00e1bados 11:00-15:00",

    // --- Messages ---
    "What message would you like on your cake? e.g. xoxo, i love you, happy birthday (max. 20 characters)": "\u00bfQu\u00e9 mensaje quieres en tu tarta? ej. xoxo, te quiero, feliz cumplea\u00f1os (m\u00e1x. 20 caracteres)",
    "If you choose an address outside of out delivery zone we will automatically cancel your delivery and send you a refund. For deliveries outside of Barcelona City please contact us.": "Si eliges una direcci\u00f3n fuera de nuestra zona de entrega, cancelaremos autom\u00e1ticamente tu pedido y te enviaremos un reembolso. Para entregas fuera de la ciudad de Barcelona, cont\u00e1ctanos.",

    // --- Yes/No ---
    "Yes": "S\u00ed",
    "No": "No",

    // --- Cart ---
    "Date:": "Fecha:",
    "Remove": "Quitar",
    "Subtotal": "Subtotal",
    "Add to Cart": "Agregar al carrito",
    "Customization cost for": "Costo de personalizaci\u00f3n para"
  };

  function tr() {
    var elements = document.querySelectorAll("[id^='hulkapps_custom_options'] label, [id^='hulkapps_custom_options'] span, [id^='hulkapps_custom_options'] option, [id^='hulkapps_custom_options'] legend, [id^='hulkapps_custom_options'] p, [id^='hulkapps_custom_options'] li, .cart-table label, .cart-table span, .cart-table td");
    elements.forEach(function(el) {
      el.childNodes.forEach(function(n) {
        if (n.nodeType === 3) {
          var t = n.textContent.trim();
          if (!t || t.length < 2) return;
          // Exact match
          if (dict[t]) {
            n.textContent = n.textContent.replace(t, dict[t]);
            return;
          }
          // Partial match for texts with prices appended
          for (var k in dict) {
            if (k.length > 3 && t.indexOf(k) === 0 && t !== dict[k]) {
              n.textContent = n.textContent.replace(k, dict[k]);
              return;
            }
          }
        }
      });
    });
    // Placeholders
    document.querySelectorAll("[id^='hulkapps_custom_options'] input[placeholder], [id^='hulkapps_custom_options'] textarea[placeholder]").forEach(function(el) {
      var ph = el.placeholder.trim();
      if (dict[ph]) el.placeholder = dict[ph];
    });
  }

  var count = 0;
  var interval = setInterval(function() {
    tr();
    count++;
    if (count > 20) clearInterval(interval);
  }, 500);

  new MutationObserver(function() { tr(); }).observe(document.body, {childList: true, subtree: true});
});